<script setup lang="ts">
const props = defineProps<{ post: PostItem }>();

const details = computed(() => {
  const items: {
    label?: string;
    content?: string | { content?: string; link?: string }[];
    link?: string;
  }[] = [];

  const { post } = props;

  if (!post.type) return items;

  if (post.type === PostType.Inspiration) {
    if (
      post.architect_name ||
      post.architect_link ||
      (post.architects?.length && post.architects.length > 0)
    ) {
      items.push({
        label: "Architekt",
        content: [
          ...(post.architect_name || post.architect_link
            ? [
                {
                  content: post.architect_name,
                  link: post.architect_link,
                },
              ]
            : []),
          ...(post.architects?.map((item) => ({
            content: item.name,
            link: item.link,
          })) || []),
        ],
        link: post.architect_link,
      });
    }

    if (post.photographer_name || post.photographer_link) {
      items.push({
        label: "Fotograf",
        content: post.photographer_name || post.photographer_link,
        link: post.photographer_link,
      });
    }
  }

  if (post.website_name || post.website_link) {
    items.push({
      label: "Strona internetowa",
      content: post.website_name || post.website_link,
      link: post.website_link,
    });
  }

  if (post.social_links?.length) {
    items.push({
      label: "Social media",
      content: post.social_links.map((item: any) => ({
        content: item.name,
        link: item.link,
      })),
    });
  }

  if (post.location_address) {
    items.push({
      label: "Lokalizacja",
      content: post.location_address,
    });
  }

  return items;
});
</script>

<template>
  <div v-if="details.length > 0" class="post-content-details px-5 lg:px-0">
    <ul
      class="post-content-details__wrapper flex items-start justify-between gap-4"
    >
      <li v-for="item in details" class="post-content-details__item">
        <PostContentDetailsItem v-bind="item" />
      </li>
    </ul>
  </div>
</template>
